import { render, staticRenderFns } from "./ResumeDocument.vue?vue&type=template&id=0b89f95b&scoped=true&"
import script from "./ResumeDocument.vue?vue&type=script&lang=js&"
export * from "./ResumeDocument.vue?vue&type=script&lang=js&"
import style0 from "./ResumeDocument.vue?vue&type=style&index=0&id=0b89f95b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b89f95b",
  null
  
)

export default component.exports